import { create } from 'zustand'
import type { DeviceContext } from '@/api/auth'

interface DeviceStoreState {
  deviceContext: DeviceContext | null
  setDeviceContext: (ctx: DeviceContext | null) => void
  clear: () => void
}

export const useDeviceStore = create<DeviceStoreState>((set) => ({
  deviceContext: null,
  setDeviceContext: (ctx) => set({ deviceContext: ctx }),
  clear: () => set({ deviceContext: null }),
}))
